import { render, staticRenderFns } from "./GiacenzeMagazzinoView.vue?vue&type=template&id=0055abc5&"
import script from "./GiacenzeMagazzinoView.vue?vue&type=script&lang=js&"
export * from "./GiacenzeMagazzinoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports